import { useCallback, useContext } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { RepairOrderContext } from '../../../providers/RepairOrderProvider/RepairOrderProvider'
import { useAddServiceItemMutation } from '../../../redux/api'
import { ServiceInfoStatusEnum } from '../../../sdk'
import { ModifiedApplicationEntry } from '../useLookupServiceDialog/transformSelectedJob'
import { useSubmitCannedJobOrMotor } from '../useLookupServiceDialog/useSubmitCannedJobOrMotor'

export const useSubmitMaintenanceSchedule = () => {
  const { accessToken } = useAccessTokenAndShopId()
  const { repairOrder } = useContext(RepairOrderContext)
  const [addServiceItem] = useAddServiceItemMutation()
  const { submitMotor } = useSubmitCannedJobOrMotor()

  const submitMaintenanceSchedules = useCallback(
    async (motor: ModifiedApplicationEntry[], oneServiceOnly: boolean) => {
      if (!repairOrder) {
        return
      }
      if (oneServiceOnly) {
        const serviceId = await addServiceItem({
          authorization: accessToken,
          serviceInfo: {
            repairOrder: repairOrder.entry!.id!,
            status: ServiceInfoStatusEnum.Recommended,
            title: 'Maintenance Schedules',
            recommendInFutureRepairOrders: true
          }
        }).unwrap()
        await submitMotor(motor, serviceId)
      } else {
        const promises = []
        for (let i = 0; i < motor.length; i++) {
          const motorApplication = motor[i]
          promises.push(submitMotor([motorApplication], undefined))
        }
        await Promise.all(promises)
      }
    },
    [accessToken, addServiceItem, repairOrder, submitMotor]
  )

  return { submitMaintenanceSchedules }
}
